import styled, { css } from 'styled-components';

export const WrapperResources = styled.div`
  ${({ theme, width }) => css`
    display: flex;
    justify-content: space-between;
    gap: 16px;
    width: ${`calc(${width || 100}% - ${!width || width === 100 ? '0px' : '8px'})`};
    min-height: 132px;
    padding-bottom: 130px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
      gap: 8px;
    }
  `}
`;

export const CardResourceImage = styled.button`
  ${({ theme, backgroundImg, size }) => css`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: ${size}%;
    min-height: 132px;
    border-radius: 16px;
    background: linear-gradient(90deg, #1F2044 47.46%, rgba(77, 80, 170, 0.44) 100%), url(${backgroundImg}) no-repeat right center;
    padding: 16px 16px 16px 24px;
    font-family: ${theme.v2.font.family.primary};
    border: none;
    cursor: pointer;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
      border-radius: 0;
      background: linear-gradient(90deg, #1F2044 47.46%, rgba(77, 80, 170, 0.44) 100%), url(${backgroundImg}) no-repeat 110% center;

    }
  `}
`;

export const CardResourceSimple = styled.button`
  ${({ theme, size }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${size}%;
    min-height: 132px;
    border-radius: 16px;
    background-color: ${theme.v2.colors.neutral.highPure};
    gap: 16px;
    border: none;
    cursor: pointer;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
      border-radius: 0;
    }
  `}
`;

export const DivContent = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    max-width: 60%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    text-align: left;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-height: 100px;
    }
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    color: ${theme.v2.colors.neutral.highPure};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `}
`;

export const Image = styled.div`
  ${() => css`
    width: 32px;
    height: 32px;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    color: ${theme.v2.colors.neutral.highPure};
    font-weight: ${theme.v2.font.weights.medium};
    display: flex;
    gap: 8px;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
  `}
`;

export const DescriptionBox = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    color: ${theme.v2.colors.neutral.highPure};
    font-weight: ${theme.v2.font.weights.medium};
    display: flex;
    gap: 8px;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
  `}
`;

export const ArrowBox = styled.p`
  ${() => css`
    transform: rotate(40deg);
    margin: 0;
    `}
`;

export const CardSimpleTitle = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    color: ${theme.v2.colors.neutral.lowDark};
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;


export const ResourcesSkeletonWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 6px;
    }
  `}
`;

export const FirstResourceWrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    display: flex;
    flex: 1.2;
    flex-direction: column;
    gap: 8px;
    justify-content: flex-end;
    padding: 20px;
    width: 340px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      border-radius: 0;
      width: 100%;
    }
  `}
`;

export const ResourceWrapper = styled.div`
  ${({ theme }) => css`
  align-items: center;
    background: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    display: flex;
    flex: 1;
    gap: 28px;
    padding: 28px 20px 20px 20px;
    width: 300px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      border-radius: 0;
      width: 100%;
    }
  `}
`;
